/**
 * ![lightBlue 50](https://mui.com/static/colors-preview/lightBlue-50-24x24.png) ![lightBlue 100](https://mui.com/static/colors-preview/lightBlue-100-24x24.png) ![lightBlue 200](https://mui.com/static/colors-preview/lightBlue-200-24x24.png) ![lightBlue 300](https://mui.com/static/colors-preview/lightBlue-300-24x24.png) ![lightBlue 400](https://mui.com/static/colors-preview/lightBlue-400-24x24.png) ![lightBlue 500](https://mui.com/static/colors-preview/lightBlue-500-24x24.png) ![lightBlue 600](https://mui.com/static/colors-preview/lightBlue-600-24x24.png) ![lightBlue 700](https://mui.com/static/colors-preview/lightBlue-700-24x24.png) ![lightBlue 800](https://mui.com/static/colors-preview/lightBlue-800-24x24.png) ![lightBlue 900](https://mui.com/static/colors-preview/lightBlue-900-24x24.png) ![lightBlue A100](https://mui.com/static/colors-preview/lightBlue-A100-24x24.png) ![lightBlue A200](https://mui.com/static/colors-preview/lightBlue-A200-24x24.png) ![lightBlue A400](https://mui.com/static/colors-preview/lightBlue-A400-24x24.png) ![lightBlue A700](https://mui.com/static/colors-preview/lightBlue-A700-24x24.png)
 */
const lightBlue = {
  /**
   * Preview: ![lightBlue 50](https://mui.com/static/colors-preview/lightBlue-50-24x24.png)
   */
  50: '#e1f5fe',
  /**
   * Preview: ![lightBlue 100](https://mui.com/static/colors-preview/lightBlue-100-24x24.png)
   */
  100: '#b3e5fc',
  /**
   * Preview: ![lightBlue 200](https://mui.com/static/colors-preview/lightBlue-200-24x24.png)
   */
  200: '#81d4fa',
  /**
   * Preview: ![lightBlue 300](https://mui.com/static/colors-preview/lightBlue-300-24x24.png)
   */
  300: '#4fc3f7',
  /**
   * Preview: ![lightBlue 400](https://mui.com/static/colors-preview/lightBlue-400-24x24.png)
   */
  400: '#29b6f6',
  /**
   * Preview: ![lightBlue 500](https://mui.com/static/colors-preview/lightBlue-500-24x24.png)
   */
  500: '#03a9f4',
  /**
   * Preview: ![lightBlue 600](https://mui.com/static/colors-preview/lightBlue-600-24x24.png)
   */
  600: '#039be5',
  /**
   * Preview: ![lightBlue 700](https://mui.com/static/colors-preview/lightBlue-700-24x24.png)
   */
  700: '#0288d1',
  /**
   * Preview: ![lightBlue 800](https://mui.com/static/colors-preview/lightBlue-800-24x24.png)
   */
  800: '#0277bd',
  /**
   * Preview: ![lightBlue 900](https://mui.com/static/colors-preview/lightBlue-900-24x24.png)
   */
  900: '#01579b',
  /**
   * Preview: ![lightBlue A100](https://mui.com/static/colors-preview/lightBlue-A100-24x24.png)
   */
  A100: '#80d8ff',
  /**
   * Preview: ![lightBlue A200](https://mui.com/static/colors-preview/lightBlue-A200-24x24.png)
   */
  A200: '#40c4ff',
  /**
   * Preview: ![lightBlue A400](https://mui.com/static/colors-preview/lightBlue-A400-24x24.png)
   */
  A400: '#00b0ff',
  /**
   * Preview: ![lightBlue A700](https://mui.com/static/colors-preview/lightBlue-A700-24x24.png)
   */
  A700: '#0091ea',
} as const;

export default lightBlue;
